import "./ArticleImage.css"

export default function ArticleImage({src, alt}) {
    return (
        <div className="ArticleImage">
            <img src={src} alt={alt}></img>
        </div>
    )
}